// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { operatorId } from './Operator';
import { z } from 'zod';
export const formulaTemplateId = (z.number());
export const formulaTemplate = z.object({
    id: formulaTemplateId,
    slug: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    expression: z.string(),
    unit: z.string().nullable(),
    precision: z.number().nullable(),
    target_type: z.string().nullable(),
    division_by_zero_mode: z.string().nullable(),
    missing_value_mode: z.string().nullable(),
    display_group: z.string().nullable(),
    display_order: z.number().nullable(),
    created_at: z.date().nullable(),
    created_by: operatorId.nullable(),
    kind: z.string(),
    archived_at: z.date().nullable(),
    archived_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
});
export const formulaTemplateInitializer = z.object({
    id: formulaTemplateId.optional(),
    slug: z.string(),
    name: z.string(),
    description: z.string().optional().nullable(),
    expression: z.string(),
    unit: z.string().optional().nullable(),
    precision: z.number().optional().nullable(),
    target_type: z.string().optional().nullable(),
    division_by_zero_mode: z.string().optional().nullable(),
    missing_value_mode: z.string().optional().nullable(),
    display_group: z.string().optional().nullable(),
    display_order: z.number().optional().nullable(),
    created_at: z.date().optional().nullable(),
    created_by: operatorId.optional().nullable(),
    kind: z.string().optional(),
    archived_at: z.date().optional().nullable(),
    archived_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
export const formulaTemplateMutator = z.object({
    id: formulaTemplateId.optional(),
    slug: z.string().optional(),
    name: z.string().optional(),
    description: z.string().optional().nullable(),
    expression: z.string().optional(),
    unit: z.string().optional().nullable(),
    precision: z.number().optional().nullable(),
    target_type: z.string().optional().nullable(),
    division_by_zero_mode: z.string().optional().nullable(),
    missing_value_mode: z.string().optional().nullable(),
    display_group: z.string().optional().nullable(),
    display_order: z.number().optional().nullable(),
    created_at: z.date().optional().nullable(),
    created_by: operatorId.optional().nullable(),
    kind: z.string().optional(),
    archived_at: z.date().optional().nullable(),
    archived_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=FormulaTemplate.js.map